
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {formRules} from "@/utils/formRules";
import router from "@/router";
import { activitySectors } from "@/utils/activitySectors";
import SimpleDialog from "@/components/SimpleDialog.vue";

@Component({
  components: { SimpleDialog },
})
export default class CompanyInfo extends Vue {

    @Prop({default: null})
    public company: any;

    get activitySectorList() {
        return activitySectors.map((activitySector) => (
          {key: activitySector, label: activitySector}
        ));
    }

    private searchUserMaster: string = null;
    private users: any[] = [];
    private rules: object = formRules;
    private loading: boolean = false;
    private valid: boolean = true;
    private confirmBlock: boolean = false;

    @Watch("searchUserMaster", {deep: true})
    public handleSearchUserMaster() {
        if (this.searchUserMaster) {
            this.loading = true;
            this.$store.dispatch("admin/users/search", {
                search: this.searchUserMaster,
            }).then((res) => {
                this.users = res.list;
                this.loading = false;
            });
        }
    }

    private mounted() {
        this.users = this.company.users;
    }

    private itemStringified = (item) => JSON.stringify(item);

    private blockUnblockCompany(): void {
        const blockedAt: string|null = this.company.blockedAt
            ? null
            : new Date().toISOString().substr(0, 19);
        const company = {
            ...this.company,
            blockedAt,
        };
        this.$store.dispatch("admin/companies/updateById", {id: company.id, company}).then((res) => {
            router.push({name: "companies"});
        }).catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: this.$t(`register.error.${err.response.data.type}`),
            });
        });
    }
}
